(function () {
  function parseCoverageFromPacking(str) {
    if (!str || typeof str !== 'string') return null;
    var m = str.match(/(\d+(?:\.\d+)?)\s*(?:sq\.?\s*ft\.?|sf|sqft)\s*\/\s*box/i);
    return m ? parseFloat(m[1], 10) : null;
  }

  function initFlooringCalc(root) {
    if (!root || root.dataset.flooringCalcInit === 'true') return;
    root.dataset.flooringCalcInit = 'true';

    var covAttr = root.getAttribute('data-coverage');
    var coverage =
      covAttr && parseFloat(covAttr, 10) > 0
        ? parseFloat(covAttr, 10)
        : parseCoverageFromPacking(root.getAttribute('data-packing-raw') || '');

    var wastePct = parseFloat(root.getAttribute('data-waste-pct') || '10', 10) || 0;
    var boxSg = root.getAttribute('data-box-sg') || 'box';
    var boxPl = root.getAttribute('data-box-pl') || 'boxes';
    var showCovRow = root.getAttribute('data-show-coverage-row') === 'true';
    var showResult = root.getAttribute('data-show-result') === 'true';
    var showAtc = root.getAttribute('data-show-atc') === 'true';
    var debug = root.getAttribute('data-debug') === 'true';
    var atcPrefix = root.getAttribute('data-atc-prefix') || 'Add';
    var atcSuffix = root.getAttribute('data-atc-suffix') || 'To Cart';
    var atcPlaceholder = root.getAttribute('data-atc-placeholder') || 'Room Size First';

    function dbg() {
      if (!debug || typeof console === 'undefined' || !console.log) return;
      console.log.apply(console, ['[Flooring calc]'].concat([].slice.call(arguments)));
    }

    dbg('init', { coverage: coverage, wastePct: wastePct, showResult: showResult, showAtc: showAtc });

    var modeDim = root.querySelector('.flooring-calc__mode-dimensions');
    var modeDirect = root.querySelector('.flooring-calc__mode-direct');
    var tabBtns = root.querySelectorAll('.flooring-calc__tab');
    var inpLen = root.querySelector('.flooring-calc__len');
    var inpWid = root.querySelector('.flooring-calc__wid');
    var inpDirect = root.querySelector('.flooring-calc__direct');
    var elRoomVal = root.querySelector('.flooring-calc__room-val');
    var cbWaste = root.querySelector('.flooring-calc__waste');
    var elResult = root.querySelector('.flooring-calc__result-text');
    var atcBtn = root.querySelector('.flooring-calc__atc');
    var atcErr = root.querySelector('.flooring-calc__atc-error');

    function boxWord(n) {
      return n === 1 ? boxSg : boxPl;
    }

    function getProductForm() {
      var fid = root.getAttribute('data-product-form-id');
      var form = fid ? document.getElementById(fid) : null;
      if (form) return form;
      var wrap = root.closest('product-form');
      return wrap ? wrap.querySelector('form.js-product-form') : document.querySelector('form.js-product-form');
    }

    function getVariantId() {
      var form = getProductForm();
      if (!form) return null;
      var inp = form.querySelector('input[name="id"]');
      return inp && inp.value ? String(inp.value) : null;
    }

    function isVariantPurchasable() {
      if (!getVariantId()) return false;

      var vp = document.querySelector('variant-picker');
      if (!vp) return true;
      if (!vp.classList.contains('variant-picker--product-available')) return false;
      if (vp.classList.contains('variant-picker--preselection')) return false;
      return true;
    }

    function readPositiveMeasure(inp) {
      if (!inp || inp.value === '') return null;
      var n = parseFloat(inp.value, 10);
      return isFinite(n) && n > 0 ? n : null;
    }

    function formatRoomAreaSqFt(n) {
      var r = Math.round(n * 100) / 100;
      return String(Number(r.toFixed(2)));
    }

    function baseSqFt() {
      if (modeDirect && !modeDirect.hidden && inpDirect) {
        return readPositiveMeasure(inpDirect);
      }
      var L = readPositiveMeasure(inpLen);
      var W = readPositiveMeasure(inpWid);
      if (L == null || W == null) return null;
      return L * W;
    }

    function bindArrowStepByOne(inp) {
      if (!inp) return;
      inp.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
        var min = parseFloat(inp.getAttribute('min') || '0', 10);
        if (!isFinite(min)) min = 0;
        e.preventDefault();
        var cur = parseFloat(inp.value, 10);
        if (!isFinite(cur)) {
          if (e.key === 'ArrowUp') cur = 0;
          else return;
        }
        var delta = e.key === 'ArrowUp' ? 1 : -1;
        var next = Math.round((cur + delta) * 100) / 100;
        if (next < min) next = min;
        inp.value = next <= 0 ? '' : String(Number(next.toFixed(2)));
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function computeBoxes() {
      var base = baseSqFt();
      if (base == null || !coverage || coverage <= 0) return null;
      var withWaste = base;
      var wasteOn = !!(cbWaste && cbWaste.checked);
      if (wasteOn) withWaste = (base * (100 + wastePct)) / 100;
      var boxes = Math.ceil(withWaste / coverage);
      var totalSqFromBoxes = Math.round(boxes * coverage * 100) / 100;
      return {
        base: base,
        withWaste: withWaste,
        wasteOn: wasteOn,
        boxes: boxes,
        totalProvided: totalSqFromBoxes.toFixed(2)
      };
    }

    function hideAtcError() {
      if (!atcErr) return;
      atcErr.hidden = true;
      atcErr.textContent = '';
    }

    function showAtcError(msg) {
      if (!atcErr || !msg) return;
      atcErr.textContent = msg;
      atcErr.hidden = false;
    }

    function updateAtcButton(calc) {
      if (!atcBtn || !showAtc) return;
      hideAtcError();
      var vid = getVariantId();
      var purch = isVariantPurchasable();
      if (!calc || calc.boxes < 1) {
        atcBtn.textContent = atcPlaceholder;
        atcBtn.disabled = true;
        return;
      }
      atcBtn.textContent = atcPrefix + ' ' + calc.boxes + ' ' + boxWord(calc.boxes) + ' ' + atcSuffix;
      atcBtn.disabled = !vid || !purch;
    }

    function recalc() {
      var base = baseSqFt();
      if (elRoomVal && modeDim && !modeDim.hidden) {
        elRoomVal.textContent = base != null ? formatRoomAreaSqFt(base) : '—';
      }

      var calc = computeBoxes();
      updateAtcButton(calc);

      if (!elResult || !showResult) return;

      if (base == null) {
        elResult.textContent = '—';
        return;
      }

      if (!coverage || coverage <= 0) {
        elResult.textContent = '—';
        return;
      }

      if (!calc) return;

      var verb = calc.boxes === 1 ? 'covers' : 'cover';
      elResult.textContent =
        calc.boxes + ' ' + boxWord(calc.boxes) + ' ' + verb + ' ' + calc.totalProvided + ' sq ft';
    }

    function setTabActive(mode) {
      tabBtns.forEach(function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-mode') === mode ? 'true' : 'false');
      });
    }

    function switchToDirect() {
      if (!modeDim || !modeDirect) return;
      modeDim.hidden = true;
      modeDirect.hidden = false;
      setTabActive('direct');
      recalc();
    }

    function switchToDim() {
      if (!modeDim || !modeDirect) return;
      modeDim.hidden = false;
      modeDirect.hidden = true;
      setTabActive('dimensions');
      recalc();
    }

    function normalizeMeasureOnBlur(inp) {
      if (!inp) return;
      var raw = inp.value;
      if (raw === '' || raw == null) return;
      var n = parseFloat(raw, 10);
      if (!isFinite(n) || n <= 0) {
        inp.value = '';
        return;
      }
      inp.value = String(Number(n.toFixed(2)));
    }

    ['input', 'change'].forEach(function (ev) {
      if (inpLen) inpLen.addEventListener(ev, recalc);
      if (inpWid) inpWid.addEventListener(ev, recalc);
      if (inpDirect) inpDirect.addEventListener(ev, recalc);
      if (cbWaste) cbWaste.addEventListener(ev, recalc);
    });

    [inpLen, inpWid, inpDirect].forEach(function (inp) {
      if (!inp) return;
      bindArrowStepByOne(inp);
      inp.addEventListener('wheel', function (e) {
        if (document.activeElement === inp) e.preventDefault();
      }, { passive: false });
      inp.addEventListener('blur', function () {
        normalizeMeasureOnBlur(inp);
        if (inp === inpDirect && coverage && coverage > 0) {
          var val = parseFloat(inp.value, 10);
          if (isFinite(val) && val > 0 && val < coverage) {
            inp.value = String(Number(coverage.toFixed(2)));
          }
        }
        recalc();
      });
    });

    var formForVariant = getProductForm();
    if (formForVariant) {
      var idInput = formForVariant.querySelector('input[name="id"]');
      if (idInput) idInput.addEventListener('change', recalc);
    }

    tabBtns.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var m = tab.getAttribute('data-mode');
        if (m === 'direct') switchToDirect();
        else switchToDim();
      });
    });

    if (atcBtn && showAtc) {
      atcBtn.addEventListener('click', function () {
        var calc = computeBoxes();
        if (!calc || calc.boxes < 1) return;
        if (!getVariantId()) {
          showAtcError('Select an option for this product.');
          return;
        }
        if (!isVariantPurchasable()) {
          showAtcError('This variant is unavailable.');
          return;
        }

        hideAtcError();
        var form = getProductForm();
        if (!form) {
          showAtcError('Could not add to cart.');
          return;
        }

        var qtyInp = form.querySelector('[name="quantity"]');
        if (qtyInp) qtyInp.value = calc.boxes;

        var addBtn = form.querySelector('button[name="add"]');
        if (!addBtn) {
          showAtcError('Could not add to cart.');
          return;
        }

        atcBtn.classList.add('is-loading');
        atcBtn.disabled = true;
        addBtn.click();

        setTimeout(function () {
          atcBtn.classList.remove('is-loading');
          recalc();
        }, 1500);
      });
    }

    root._flooringRecalc = recalc;
    recalc();
  }

  function refreshAllFlooringCalcs() {
    document.querySelectorAll('.flooring-calc').forEach(function (root) {
      if (typeof root._flooringRecalc === 'function') {
        root._flooringRecalc();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.flooring-calc').forEach(initFlooringCalc);
  }

  if (!window._flooringCalcGlobalListeners) {
    window._flooringCalcGlobalListeners = true;
    document.addEventListener('on:variant:change', refreshAllFlooringCalcs);
    document.addEventListener('product:add-to-cart-state-updated', refreshAllFlooringCalcs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
